/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

// useGaPageViews.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { sendPageView } from '@services/ga/send-page-view';
import { emitTelemetry } from '@services/telemetry/telemetry';

export default function useGaPageViews() {
  const location = useLocation();

  useEffect(() => {
    // fire on initial load and every navigation
    const path = location.pathname + location.search;
    sendPageView(path);
    // Authenticated usage telemetry (no-op when unauthenticated). GA is kept.
    emitTelemetry({ event_type: 'page_view', path });
  }, [location.pathname, location.search]);
}